
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.489 5.054c-.113-.527-.865-.527-.978 0L7.317 10.63A3 3 0 014.383 13H3a1 1 0 110-2h1.383a1 1 0 00.978-.79l1.194-5.575C7.12 2 10.88 2 11.445 4.635l3.066 14.31c.113.528.865.528.978 0l1.194-5.574A3 3 0 0119.617 11H21a1 1 0 110 2h-1.383a1 1 0 00-.978.79l-1.194 5.575c-.565 2.635-4.325 2.635-4.89 0L9.49 5.055z"}})])
          )
        }
      }
    